import { render } from "./ChoiceEditor.vue?vue&type=template&id=550aeee2&ts=true"
import script from "./ChoiceEditor.vue?vue&type=script&lang=ts"
export * from "./ChoiceEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__